import React, { useRef } from "react"
import { DataGrid, Button, Template } from "devextreme-react"
import {
  Editing,
  Column,
  Lookup,
  StateStoring,
  ColumnChooser,
  ColumnFixing,
  Pager,
  FilterPanel,
  Grouping,
  GroupPanel,
  HeaderFilter,
  SearchPanel,
  Button as GridButton,
  FilterRow,
  Scrolling,
} from "devextreme-react/data-grid"
import DataSource from "devextreme/data/data_source"
import notify from "devextreme/ui/notify"
import { RiMessageFill } from "react-icons/ri"

import { topicDataStore, applicationDataStore } from "../shared/ClientStores"
import { hasAccessTo } from "../../authentication"
import { PageTitle, LockButton } from "../shared/StyledComponents"
import { topicLocker } from "../operations/client"
import SEO from "../../seo"

const topicDataSource = new DataSource({ store: topicDataStore })

const Topics = () => {
  const topicsGrid = useRef(null)

  const refreshMessageGridClickHandler = () => {
    topicsGrid.current.instance.refresh(true)
  }
  const lockButtonRenderHandler = ({ data }) => (
    <LockButton onClick={lockClickHandler(data.id)} lockId={data.lockId} />
  )
  const lockClickHandler = id => async () => {
    try {
      await topicLocker(id)
      topicsGrid.current.instance.refresh(false)
    } catch (error) {
      notify(`Changing lock status failed: ${error.message}`, "error")
    }
  }
  return (
    <>
      <SEO title="Topics" />
      <PageTitle icon={RiMessageFill}>Topics</PageTitle>
      <DataGrid
        columnAutoWidth={true}
        columnResizingMode="widget"
        dataSource={topicDataSource}
        hoverStateEnabled={true}
        ref={topicsGrid}
        rowAlternationEnabled={true}
        showBorders={true}
        visible={hasAccessTo("topic.r")}
        onEditorPreparing={function(e) {
          if (
            e.value &&
            e.parentType === "dataRow" &&
            e.dataField === "applicationId"
          ) {
            e.editorOptions.value = e.value.toString()
            e.editorOptions.onValueChanged = function(args) {
              e.setValue(parseInt(args.value))
            }
          }
        }}
        onToolbarPreparing={e => {
          e.toolbarOptions.items.unshift({
            location: "before",
            template: "refreshGrid",
          })
        }}
      >
        <Column
          caption="Application"
          dataField="applicationId"
          dataType="number"
          allowEditing={false}
        >
          <Lookup
            dataSource={{
              store: applicationDataStore,
              map: item => {
                return { ...item, id: item.id.toString() }
              },
            }}
            valueExpr="applicationId"
            displayExpr="title"
          />
        </Column>
        <Column allowEditing={false} dataField="title" dataType="string" />
        <Column dataField="enable" dataType="boolean" />
        <Column type="buttons" showInColumnChooser={false}>
          <GridButton name="edit" />
          <GridButton name="delete" />
          <GridButton
            render={lockButtonRenderHandler}
            visible={hasAccessTo("topic.l")}
          />
        </Column>
        <ColumnChooser
          allowSearch={true}
          enabled={true}
          height="400"
          mode="select"
        />
        <ColumnFixing enabled={true} />
        <Editing
          mode="cell"
          useIcons={true}
          allowUpdating={hasAccessTo("topic.u")}
        />
        <FilterPanel visible={true} />
        <FilterRow visible={true} />
        <Grouping contextMenuEnabled={true} />
        <GroupPanel visible={true} />
        <HeaderFilter visible={true} />
        <Pager
          visible={true}
          allowedPageSizes={[10, 20, 50, 100]}
          showPageSizeSelector={true}
          showNavigationButtons={true}
          showInfo={true}
        />
        <Scrolling showScrollbar="always" />
        <SearchPanel visible={true} />
        <StateStoring
          enabled={true}
          type="localStorage"
          storageKey="profile-topics"
        />
        <Template name="refreshGrid">
          <Button icon="refresh" onClick={refreshMessageGridClickHandler} />
        </Template>
      </DataGrid>
    </>
  )
}

export { Topics }
export default Topics
